
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 1800 100"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"wave",attrs:{"d":"M0 63.667S405.202-38.347 1016.034 15.888c311.61 27.668 783.966-5.23 783.966-5.23V100H0z"}})])
          )
        }
      }
    